import { FC } from 'react';
import { useGetDomainQuery } from '../../graphql/generated/operations/domain.ts';
import { Avatar, Chip } from '@mui/material';

export interface DomainChipProps {
  domainId: string;
}

function getContrastTextColor(hexColor?: string | null): string {
  if (!hexColor) {
    return '#000000';
  }

  // Convert hex to RGB
  let r = parseInt(hexColor.substring(1, 3), 16);
  let g = parseInt(hexColor.substring(3, 5), 16);
  let b = parseInt(hexColor.substring(5, 7), 16);

  // Calculate luminance
  let luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;

  // Return black for bright colors, white for dark colors
  return luminance > 0.5 ? '#000000' : '#FFFFFF';
}

export const DomainChip: FC<DomainChipProps> = ({ domainId }) => {
  const { data } = useGetDomainQuery({ variables: { id: domainId } });

  if (!data) {
    return null;
  }

  const domain = data.domain;

  return (
    <Chip
      size="medium"
      avatar={domain.iconUrl ? <Avatar src={domain.iconUrl} /> : undefined}
      sx={{
        backgroundColor: domain.color,
        color: getContrastTextColor(domain.color)
      }}
      label={domain.title}
    />
  );
};
